import { Component, Input } from '@angular/core';
import { BaseCmsComponent } from '@kion/data-models';
import { Router } from '@angular/router';

@Component({
  selector: 'kion-cms-large-login',
  templateUrl: './large-login.component.html',
  styleUrls: ['./large-login.component.scss']
})
export class LargeLoginComponent {

  @Input() component: BaseCmsComponent;

  constructor(private router: Router) { }

  loginClicked(): void {
    this.router.navigate(["auth"]).then(() => { })
  }
}
